/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-declarations */

import { PureComponent } from 'react';
import getOrCreateWidgetStore from '../utils/getOrCreateWidgetStore';
import { jsx as _jsx } from "react/jsx-runtime";
const withWidgetState = Component => {
  class Wrapper extends PureComponent {
    constructor(props) {
      super(props);
      this.handleUpdatedState = ({
        instance: widgetState
      }) => {
        this.setState({
          widgetState: widgetState.getState()
        });
      };
      this.handleSetCallStatus = callStatus => {
        this.WidgetStore.updateState(state => state.set('callStatus', callStatus));
      };
      this.handleSetThirdPartyActive = isActive => {
        this.WidgetStore.updateState(state => state.set('isThirdPartyActive', isActive));
      };
      this.handleSetThirdPartyCallDirection = callDirection => {
        this.WidgetStore.updateState(state => state.set('thirdPartyCallDirection', callDirection));
      };
      this.WidgetStore = getOrCreateWidgetStore();
      window.hswidgetstore = window.hswidgetstore || this.WidgetStore;
      this.state = {
        widgetState: this.WidgetStore.getState()
      };
    }
    componentDidMount() {
      this.WidgetStore.addListener(this.handleUpdatedState);
    }
    componentWillUnmount() {
      this.WidgetStore.removeListener(this.handleUpdatedState);
    }
    render() {
      const {
        widgetState
      } = this.state;
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        widgetState: widgetState,
        onSetCallStatus: this.handleSetCallStatus,
        onSetThirdPartyActive: this.handleSetThirdPartyActive,
        onSetThirdPartyCallDirection: this.handleSetThirdPartyCallDirection
      }));
    }
  }
  Wrapper.displayName = 'WithWidgetState';
  return Wrapper;
};
export default withWidgetState;